import {
  ForkKnifeIcon, BeerBottleIcon, CoffeeIcon, PackageIcon,
} from "@phosphor-icons/react";

export const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export const CATEGORY_ICON = {
  Food: ForkKnifeIcon,
  Bar: BeerBottleIcon,
  Beverage: CoffeeIcon,
  Snacks: PackageIcon,
  "Room Service": PackageIcon,
};

export const CATEGORY_TONE = {
  Food: "bg-[hsl(140_50%_92%)] text-[hsl(140_40%_30%)]",
  Bar: "bg-[hsl(45_82%_88%)] text-[hsl(38_62%_35%)]",
  Beverage: "bg-secondary/15 text-secondary",
  Snacks: "bg-primary/15 text-primary",
  "Room Service": "bg-muted text-muted-foreground",
};

export const EMPTY_ITEM = {
  name: "",
  category: "Food",
  price: "",
  gst_rate: 5,
  sku: "",
  track_stock: false,
  stock: 0,
  min_stock: 5,
  is_active: true,
  unit_type: "unit",
  bottle_size_ml: 750,
  peg_size_ml: 30,
};

// Peg-aware stock helpers
export const remainingPegs = (mi) => {
  if (mi.unit_type !== "peg" || !mi.peg_size_ml) return null;
  return Math.floor(Number(mi.stock || 0) / Number(mi.peg_size_ml));
};

export const isOutOfStock = (mi) => {
  if (!mi.track_stock) return false;
  if (mi.unit_type === "peg" && mi.peg_size_ml) {
    return Number(mi.stock || 0) < Number(mi.peg_size_ml);
  }
  return Number(mi.stock || 0) <= 0;
};
